<template>
  <div class="ag-cal">
    <div class="ag-cal__semana">
      <span v-for="d in ['L', 'M', 'X', 'J', 'V', 'S', 'D']" :key="d">{{ d }}</span>
    </div>
    <div class="ag-cal__grid">
      <span v-for="n in huecoInicial" :key="`h${n}`" class="ag-cal__hueco"></span>
      <button
        v-for="c in celdas"
        :key="c.iso"
        type="button"
        class="ag-cal__dia"
        :class="[`n${c.nivel}`, { hoy: c.iso === hoyISO, sel: c.iso === seleccionado, futuro: c.futuro }]"
        :title="`${c.dia}: ${euros(c.total)}`"
        :aria-label="`Día ${c.dia}, ${euros(c.total)}`"
        :aria-pressed="c.iso === seleccionado"
        @click="$emit('seleccionar', c.iso === seleccionado ? null : c.iso)"
      >
        <span class="ag-cal__num">{{ c.dia }}</span>
        <span v-if="c.total > 0" class="ag-cal__imp">{{ compacto(c.total) }}</span>
      </button>
    </div>
    <div class="ag-cal__pie">
      <span>Menos</span>
      <i v-for="(color, i) in ESCALA_CALOR" :key="i" :style="{ background: color }"></i>
      <span>Más</span>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { diasDelMes, diaSemanaLunes, nivelCalor, euros, ESCALA_CALOR, aISO } from '../../utils/analisisGastos';

export default {
  name: 'AgCalendarioMes',
  props: {
    mes: { type: String, required: true },
    totalesDia: { type: Object, default: () => ({}) },
    seleccionado: { type: String, default: null }
  },
  emits: ['seleccionar'],
  setup(props) {
    const hoyISO = aISO(new Date());
    const huecoInicial = computed(() => diaSemanaLunes(`${props.mes}-01`));
    const celdas = computed(() => {
      const n = diasDelMes(props.mes);
      const dias = Array.from({ length: n }, (_, i) => {
        const iso = `${props.mes}-${String(i + 1).padStart(2, '0')}`;
        return { iso, dia: i + 1, total: props.totalesDia[iso] || 0, futuro: iso > hoyISO };
      });
      const max = Math.max(...dias.map((d) => d.total), 0);
      return dias.map((d) => ({ ...d, nivel: nivelCalor(d.total, max) }));
    });
    const compacto = (v) => (v >= 1000 ? `${(v / 1000).toFixed(1).replace('.', ',')}k` : Math.round(v));
    return { huecoInicial, celdas, hoyISO, euros, compacto, ESCALA_CALOR };
  }
};
</script>

<style scoped>
.ag-cal__semana, .ag-cal__grid { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); gap: 4px; }
.ag-cal__semana { font-size: 0.7rem; color: var(--tinta-suave); text-align: center; margin-bottom: 4px; font-weight: 600; }
.ag-cal__dia {
  aspect-ratio: 1 / 0.85;
  border: 0;
  border-radius: 0.55rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.25rem 0.35rem;
  font-size: 0.7rem;
  background: #eef1ec;
  color: var(--tinta);
  transition: transform 0.12s, box-shadow 0.12s;
  min-width: 0;
}
.ag-cal__dia:hover { transform: translateY(-1px); box-shadow: 0 3px 8px rgba(22, 53, 40, 0.15); }
.ag-cal__dia.n1 { background: #c9e3d2; }
.ag-cal__dia.n2 { background: #8cc3a0; }
.ag-cal__dia.n3 { background: #3f8f63; color: #fff; }
.ag-cal__dia.n4 { background: #1a5a3a; color: #fff; }
.ag-cal__dia.futuro { background: transparent; border: 1px dashed var(--linea); color: var(--tinta-suave); }
.ag-cal__dia.hoy { box-shadow: inset 0 0 0 2px #eb6834; }
.ag-cal__dia.sel { box-shadow: 0 0 0 2px var(--superficie), 0 0 0 4px var(--marca-oscura); }
.ag-cal__num { font-weight: 700; opacity: 0.75; }
.ag-cal__imp { font-family: var(--fuente-cifra); font-variant-numeric: tabular-nums; font-size: 0.78rem; align-self: flex-end; line-height: 1; }
.ag-cal__pie { display: flex; align-items: center; justify-content: flex-end; gap: 3px; margin-top: 0.6rem; font-size: 0.7rem; color: var(--tinta-suave); }
.ag-cal__pie i { width: 0.8rem; height: 0.8rem; border-radius: 3px; display: inline-block; }
.ag-cal__pie span { margin: 0 0.25rem; }
@media (max-width: 420px) {
  .ag-cal__imp { font-size: 0.62rem; }
}
</style>
